import { render, staticRenderFns } from "./profile_fields.vue?vue&type=template&id=060295cc&scoped=true&"
import script from "./profile_fields.vue?vue&type=script&lang=js&"
export * from "./profile_fields.vue?vue&type=script&lang=js&"
import style0 from "./profile_fields.vue?vue&type=style&index=0&id=060295cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060295cc",
  null
  
)

export default component.exports